var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{staticClass:"d-md-block d-flex justify-content-center mb-4",attrs:{"sitekey":_vm.captchaSiteKey,"theme":'dark',"loadRecaptchaScript":true},on:{"expired":_vm.markRecaptchaAsExpired,"verify":_vm.markRecaptchaAsVerified}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349e2728","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Captcha.vue
// module id = null
// module chunks = 